import SingleEssayTableContainer from "home/components/single_essay/containers/single_essay_table_container"

export {
  SingleEssayTableContainer
}
